export const formatPhoneNumber = (str: string) => {
    let result = str;
    result = result.replace(/[^0-9]+/g, ""); // allow only number
    result = result.replace(/[^0-9]/gi, ""); // removes all the spaces and other characters other than number
    result = result.slice(0, 10);
    return result;
};
